import React from 'react';
import { Link } from 'react-router-dom';
import './BioPage.css';

export default function FounderMohit() {
  return (
    <main className="bioContainer">
      <h1>Founder — Mohit Singh</h1>

      {/* Hero card with larger portrait (same image file as About page) */}
      <section className="bioCard bioCardHero">
        <img
          src="/images/mohit.png"
          alt="Mohit Singh"
          className="bioAvatarLarge"
          width="1200"
          height="1200"
          loading="eager"
          sizes="(max-width: 900px) 60vw, 340px"
        />

        <div className="bioHeader">
          <h2>Building playful robotics for every home</h2>
          <p className="bioSubtitle">Founder, ChronoTech Robotics</p>

          <div className="bioBody">
            <p>
              Mohit leads his vision and product direction—turning complex robotics into
              friendly, creative tools for young makers. He focuses on rapid prototyping, electronics,
              and shipping learning experiences that kids love.
            </p>
            <p>
              Before ChronoTech Robotics, Mohit worked across embedded systems and Arduino/ESP32 projects,
              teaching hands-on STEM in live and self-paced formats. His approach blends simple,
              repeatable builds with real engineering principles so students gain confidence fast.
            </p>

            <ul className="bioList">
              <li><strong>Focus:</strong> product, R&amp;D, hardware design</li>
              <li><strong>Teaches:</strong> Robo Kids live classes and demos</li>
              <li><strong>Belief:</strong> “Make it simple. Ship it. Improve with students.”</li>
            </ul>

            <div className="bioActions">
              <Link className="bioBackLink secondary" to="/about">← Back to About</Link>
              <Link className="bioBackLink" to="/robokidslanding">See Classes</Link>
              <Link className="bioBackLink" to="/guides">View Guides</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Optional long-form section to mirror Kaitlyn’s page */}
      <section className="bioLong">
        <h3>Why ChronoTech</h3>
        <p>
          Mohit started ChronoTech to make robotics approachable for families—clear instructions, safe
          hardware, and projects that spark curiosity from day one.
        </p>

        <h3>Engineering Approach</h3>
        <p>
          Prototypes are iterated in the open: test with students, capture feedback, and refine.
          The result is a curriculum that scales from first circuits to autonomous builds.
        </p>
      </section>
    </main>
  );
}
